import { apiClient } from "../lib/api";

export const trainingApi = {
  // Dashboard
  dashboard: () => apiClient.get("/training/dashboard"),
  employeeProfile: (employeeId) => apiClient.get(`/training/employees/${employeeId}/profile`),
  listEmployeesForAssignment: () => apiClient.get("/employees/training-lookup"),

  // Source register
  listSources: () => apiClient.get("/training/sources"),
  getSource: (id) => apiClient.get(`/training/sources/${id}`),
  uploadSource: (formData) => apiClient.post("/training/sources", formData, { headers: { "Content-Type": "multipart/form-data" } }),
  reviewSource: (id, payload) => apiClient.post(`/training/sources/${id}/review`, payload),
  listSections: (sourceId) => apiClient.get("/training/sections", { params: { source_id: sourceId || undefined } }),
  classifySection: (id, payload) => apiClient.patch(`/training/sections/${id}`, payload),

  // Courses
  listCourses: (programId) => apiClient.get("/training/courses", { params: { program_id: programId || undefined } }),
  getCourse: (id) => apiClient.get(`/training/courses/${id}`),
  createCourse: (payload) => apiClient.post("/training/courses", payload),
  updateCourse: (id, payload) => apiClient.patch(`/training/courses/${id}`, payload),
  addLesson: (courseId, payload) => apiClient.post(`/training/courses/${courseId}/lessons`, payload),
  moveCourseStatus: (courseId, targetStatus) => apiClient.post(`/training/courses/${courseId}/status`, null, { params: { target_status: targetStatus } }),
  newCourseVersion: (courseId) => apiClient.post(`/training/courses/${courseId}/new-version`),

  // Quiz engine
  listQuizBanks: (courseId) => apiClient.get("/training/quiz-banks", { params: { course_id: courseId || undefined } }),
  createQuizBank: (payload) => apiClient.post("/training/quiz-banks", payload),
  listQuestions: (bankId) => apiClient.get(`/training/quiz-banks/${bankId}/questions`),
  addQuestion: (bankId, payload) => apiClient.post(`/training/quiz-banks/${bankId}/questions`, payload),
  listAttempts: (employeeId, bankId) => apiClient.get("/training/attempts", { params: { employee_id: employeeId || undefined, bank_id: bankId || undefined } }),

  // Certifications & practical evaluations
  listCertificationDefs: () => apiClient.get("/training/certifications"),
  createCertificationDef: (params) => apiClient.post("/training/certifications", null, { params }),
  listEvaluations: (employeeId) => apiClient.get("/training/practical-evaluations", { params: { employee_id: employeeId || undefined } }),
  recordEvaluation: (payload) => apiClient.post("/training/practical-evaluations", payload),
  listEmployeeCertifications: (employeeId) => apiClient.get("/training/employee-certifications", { params: { employee_id: employeeId || undefined } }),

  // Assignments, waivers, retraining
  listAssignments: (employeeId, courseId) => apiClient.get("/training/assignments", { params: { employee_id: employeeId || undefined, course_id: courseId || undefined } }),
  assignCourse: (payload) => apiClient.post("/training/assignments", payload),
  approveAssignment: (id, notes) => apiClient.post(`/training/assignments/${id}/approve`, null, { params: { notes: notes || undefined } }),
  listWaivers: (employeeId) => apiClient.get("/training/waivers", { params: { employee_id: employeeId || undefined } }),
  approveWaiver: (payload) => apiClient.post("/training/waivers", payload),
  listRetraining: (employeeId) => apiClient.get("/training/retraining", { params: { employee_id: employeeId || undefined } }),

  // Employee self-service
  myAssignments: () => apiClient.get("/employee-training/my-assignments"),
  getCourseForEmployee: (courseId) => apiClient.get(`/employee-training/courses/${courseId}`),
  getQuestionsForEmployee: (bankId) => apiClient.get(`/employee-training/quiz-banks/${bankId}/questions`),
  completeLesson: (assignmentId, lessonId) => apiClient.post(`/employee-training/assignments/${assignmentId}/lessons/${lessonId}/complete`),
  submitQuizAttempt: (bankId, assignmentId, answers) => apiClient.post(`/employee-training/quiz-banks/${bankId}/attempt`, { answers }, { params: { assignment_id: assignmentId || undefined } }),
  myCertifications: () => apiClient.get("/employee-training/my-certifications"),
  myRetraining: () => apiClient.get("/employee-training/my-retraining"),
  acknowledgeCourse: (courseId) => apiClient.post(`/employee-training/courses/${courseId}/acknowledge`, { course_id: courseId }),
};
